import React from "react";
import Nav from "./Components/Nav";
import Footer from "./Components/Footer";
import CHFrFAQBody from "./Components/BodyFrFAQ";

class CHFrFAQ extends React.Component {
  render() {
    return (
      <>
        <Nav />
        <CHFrFAQBody />
        <Footer />
      </>
    );
  }
}

export default CHFrFAQ;
